import { memo } from "react";
import { Box, Container } from "@mui/material";

const VideoPage = memo(() => {
    const videoId = "GaLROsdGo5Q";

    return (
        <Container maxWidth="lg">
            <Box
                sx={{
                    borderRadius: 2,
                    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                    bgcolor: "background.paper",
                    background: "transparent",
                    m: 3,
                }}
            >
                <Box
                    sx={{
                        position: "relative",
                        width: "100%",
                        background: "transparent",
                        paddingTop: "56.25%", // 16:9 Aspect Ratio
                        borderRadius: 1,
                        overflow: "hidden",
                        boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
                    }}
                >
                    <iframe
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            border: 0,
                            background: "transparent",
                        }}
                        src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1`}
                        title="YouTube video"
                        allow="accelerometer; autoplay; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                </Box>
            </Box>
        </Container>
    );
});

export default VideoPage;
